import React from "react";

const Challenges = props => {

  return (
    <>
      <section className="challenges">
        <h1>Challenges</h1>
        <div className="info">

          {props.work.focus.challenges.content.map((chal, i) => <p key={i}>{chal}</p>)}

        </div>
      </section>
    </>
  )
}

export default Challenges;